(function (aimi_mdcdot_email_api, $, app, undefined) {

  app.apis['emailVariant'] = function () {
    return {
      'list': function (campaignId) {
        return app.getRequest(`/api/email/list/${campaignId}`, {}, function () {
        }, function () {
        });
      },
      'get': function (id) {
        return app.getRequest(`/api/email/campaign/${id}`, {}, function () {
        }, function (response) {
          app.notify('error', response);
        });
      },
      'delete': function (id) {
        return app.deleteRequest(`/api/email/campaign/${id}`, {}, function () {
        }, function (response) {
          app.notify('error', response);
        });
      },
      'getCampaignByCategory': function (categoryId) {
        return app.getRequest(`/api/campaign/campaign/by-category/${categoryId}`, {}, function () {
        }, function () {
        });
      },
      'imageCollections': function (id) {
        return app.getRequest(`/api/image/collection/by-email-campaign/${id}`, {}, function () {
        }, function () {
        });
      },
      'add': function (requestData) {
        return app.postRequest(`/api/email/campaign`, requestData, function () {
        }, function () {
        });
      },

      'update': function (id, requestData) {
        return app.putRequest(`/api/email/campaign/${id}`, requestData, function () {
        }, function () {
        });
      },

      'save': async function (requestData) {
        if (app.isEmpty(requestData.id)) {
          return this.add(requestData)
        } else {
          return this.update(requestData.id, requestData)
        }
      },

      'reset': function (id, requestData) {
        return app.putRequest(`/api/email/campaign/reset/${id}`, requestData, function () {
        }, function () {
        });
      },

      build: function (emailCampaignId, partial = false, keepScheduled = false) {
        let url  = `/api/email/build/`;
        url = `${url}${emailCampaignId}?partial=${partial}&keepScheduled=${keepScheduled}`;
        return app.getRequest(url, {}, function () {
        }, function () {
        });
      }
    }
  }();

  app.apis['mdcdot'] = app.apis['mdcdot'] || {};

  app.apis['mdcdot']['emailVariant'] = {
    'list': function (url, sortBy, sortByDirection, searchParams) {

      if (!app.isEmpty(sortBy)) {
        url = Utils.addParamToURL(url, {'sortField': sortBy});
      }

      if (!app.isEmpty(sortByDirection)) {
        url = Utils.addParamToURL(url, {'sortDirection': sortByDirection});
      }

      if (!app.isEmpty(searchParams)) {
        const filterHash = objectHash.sha1(searchParams);
        url = Utils.appendQueryString(url, Utils.jsonToQueryString(searchParams));
        url = Utils.appendQueryString(url, Utils.jsonToQueryString({filterHash: filterHash}));
      }

      return app.getRequest(url, {}, function () {
      }, function () {
      }, '');
    },
    refresh: function (id, searchParams) {
      let url = `/api/mdcdot/email-variants/${id}/data`;

      if (!app.isEmpty(searchParams)) {
        const filterHash = objectHash.sha1(searchParams);
        url = Utils.appendQueryString(url, Utils.jsonToQueryString(searchParams));
        url = Utils.appendQueryString(url, Utils.jsonToQueryString({filterHash: filterHash}));
      }

      return app.postRequest(url, searchParams, function () {
      }, function () {
      }, '');
    },
  };

}(window.aimi_mdcdot_email_api = window.aimi_mdcdot_email_api || {}, jQuery, PreBuilt));
